module.exports = __webpack_public_path__ + "img/0Q3A2198_L_Wood_MockedUp.8c7438ca.jpg";